export default __webpack_public_path__ + "static/media/33.8bc150ce.jpg";